export default __webpack_public_path__ + "locales/nl/JavascriptSdk.json?hash=0411c84cd185ffefbd9e5c8dc63f8017";